var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22302",
    "data-name": "\\uADF8\\uB8F9 22302",
    transform: "translate(-1299 -7713)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28544",
    "data-name": "\\uC0AC\\uAC01\\uD615 28544",
    width: 24,
    height: 24,
    transform: "translate(1299 7713)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M20.6,12.5a2.473,2.473,0,0,0-1.776-1.776c-1.55-.42-7.813-.42-7.813-.42s-6.263,0-7.813.42A2.473,2.473,0,0,0,1.42,12.5,26.019,26.019,0,0,0,1,17.306a25.83,25.83,0,0,0,.42,4.81A2.473,2.473,0,0,0,3.2,23.892c1.55.42,7.813.42,7.813.42s6.263,0,7.813-.42A2.473,2.473,0,0,0,20.6,22.116a25.83,25.83,0,0,0,.42-4.81A26.019,26.019,0,0,0,20.6,12.5ZM9.006,20.308v-6l5.2,3Z",
    transform: "translate(1299.992 7707.694)",
    fill: "#212529"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon6);
export default __webpack_public_path__ + "static/media/FooterIcon6.1b12a41570475ecd6d366bca24db1c7b.svg";
export { ForwardRef as ReactComponent };